export default function CTAStrip() {
  return (
    <section className="bg-tropical-teal relative overflow-hidden">
      {/* Wave Pattern Overlay */}
      <div className="absolute inset-0 opacity-10">
        <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <pattern id="wave-cta" x="0" y="0" width="100" height="100" patternUnits="userSpaceOnUse">
            <path d="M0 50 Q 25 30, 50 50 T 100 50" stroke="white" fill="none" strokeWidth="2" />
          </pattern>
          <rect width="100%" height="100%" fill="url(#wave-cta)" />
        </svg>
      </div>

      {/* Decorative Palm Leaf */}
      <div className="absolute bottom-4 right-10 opacity-20 hidden md:block">
        <i className="ri-plant-line text-white text-7xl"></i>
      </div>

      <div className="max-w-6xl mx-auto px-6 py-16 relative z-10">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <p className="text-white text-2xl md:text-3xl font-medium text-center md:text-left max-w-2xl">
            Not sure what you need? Call and we'll point you in the right direction.
          </p>
          <a
            href="tel:+17862738796"
            className="bg-coral-pink text-white px-10 py-4 rounded-full font-bold text-lg hover:bg-opacity-90 transition-all hover:scale-105 active:scale-95 flex items-center gap-3 shadow-lg whitespace-nowrap flex-shrink-0 cursor-pointer"
          >
            <i className="ri-phone-fill text-xl"></i>
            Call Now
          </a>
        </div>
      </div>
    </section>
  );
}